<p>create-ticket-schedule-view works!</p>
